import { Order } from '../Types/Order';
import { OrderRow } from '../Types/OrderRow';
import Product from '../Types/Product';

export const adformServiceAddToCartEvent = (orderRow: OrderRow) => {
  if (global.AdformAppKey) {
    window['_adftrack'] = Array.isArray(window['_adftrack'])
      ? window['_adftrack']
      : window['_adftrack']
      ? [window['_adftrack']]
      : [];
    window['_adftrack'].push({
      HttpHost: 'track.adform.net',
      pm: global.AdformAppKey,
      pagename: encodeURIComponent('Add to cart'),
      divider: encodeURIComponent('|'),
      products: [
        {
          productid: orderRow.articleNumber,
          categoryname:
            orderRow.gtmEcommerceItem?.item_category ??
            orderRow.categoryName,
          categoryid:
            orderRow.gtmEcommerceItem?.category_system_id ??
            orderRow.categorySystemId,
          productname: orderRow.name,
          productsales: (
            orderRow.priceInfo?.campaignPrice ?? orderRow.priceInfo?.price
          )?.price,
          sv1: '',
          step: 1,
        },
      ],
    });
    (function () {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src =
        'https://s2.adform.net/banners/scripts/st/trackpoint-async.js';
      var x = document.getElementsByTagName('script')[0];
      x?.parentNode?.insertBefore(s, x);
    })();
  }
};

export const adformServiceAddToWishListEvent = (product: Product) => {
  if (global.AdformAppKey) {
    window['_adftrack'] = Array.isArray(window['_adftrack'])
      ? window['_adftrack']
      : window['_adftrack']
      ? [window['_adftrack']]
      : [];
    window['_adftrack'].push({
      HttpHost: 'track.adform.net',
      pm: global.AdformAppKey,
      pagename: encodeURIComponent('Add to wishlist'),
      divider: encodeURIComponent('|'),
      products: [
        {
          productid: product.id,
          categoryname: product.category,
          categoryid: product.categorySystemId,
          productname: product.name,
          productsales: product.price.price?.price,
          sv1: '',
          step: 1,
        },
      ],
    });
    (function () {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src =
        'https://s2.adform.net/banners/scripts/st/trackpoint-async.js';
      var x = document.getElementsByTagName('script')[0];
      x?.parentNode?.insertBefore(s, x);
    })();
  }
};

export const adformServicePurchaseEvent = (order: Order) => {
  if (global.AdformAppKey) {
    window['_adftrack'] = Array.isArray(window['_adftrack'])
      ? window['_adftrack']
      : window['_adftrack']
      ? [window['_adftrack']]
      : [];
    window['_adftrack'].push({
      HttpHost: 'track.adform.net',
      pm: global.AdformAppKey,
      pagename: encodeURIComponent('Purchase'),
      divider: encodeURIComponent('|'),
      products: getMappedOrderRows(order.orderRows),
    });
    (function () {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src =
        'https://s2.adform.net/banners/scripts/st/trackpoint-async.js';
      var x = document.getElementsByTagName('script')[0];
      x?.parentNode?.insertBefore(s, x);
    })();
  }
};

export const adformServiceNewsLetterEvent = (currency: string) => {
  if (global.AdformAppKey) {
    window['_adftrack'] = Array.isArray(window['_adftrack'])
      ? window['_adftrack']
      : window['_adftrack']
      ? [window['_adftrack']]
      : [];
    window['_adftrack'].push({
      HttpHost: 'track.adform.net',
      pm: global.AdformAppKey,
      divider: encodeURIComponent('|'),
      pagename: encodeURIComponent('Newsletter Signup'),
      order: {
        currency,
      },
    });
    (function () {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src =
        'https://s2.adform.net/banners/scripts/st/trackpoint-async.js';
      var x = document.getElementsByTagName('script')[0];
      x?.parentNode?.insertBefore(s, x);
    })();
  }
};

export const adformServiceViewContentProductPageEvent = (
  currency: string
) => {
  window['_adftrack'] = Array.isArray(window['_adftrack'])
    ? window['_adftrack']
    : window['_adftrack']
    ? [window['_adftrack']]
    : [];
  window['_adftrack'].push({
    HttpHost: 'track.adform.net',
    pm: global.AdformAppKey,
    divider: encodeURIComponent('|'),
    pagename: encodeURIComponent('View content'),
    order: {
      currency: currency,
    },
  });
  (function () {
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://s2.adform.net/banners/scripts/st/trackpoint-async.js';
    var x = document.getElementsByTagName('script')[0];
    x?.parentNode?.insertBefore(s, x);
  })();
};

const getMappedOrderRows = (rows: OrderRow[]) => {
  const result: MappedOrderRow[] = [];
  rows?.map((row) => {
    result.push({
      productname: row.name,
      productid: row.articleNumber,
      productsales: row.price,
      categoryname:
        row.gtmEcommerceItem?.item_category ?? row.categoryName ?? '',
      categoryid:
        row.gtmEcommerceItem?.category_system_id ?? row.categorySystemId,
      step: 1,
      sv1: '',
    });
  });

  return result;
};

interface MappedOrderRow {
  productid: string;
  categoryname: string;
  categoryid: string;
  productname: string;
  productsales: string;
  sv1: string;
  step: number;
}
